import React from "react";
import { useTheme,Grid, Paper, Typography, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { useHistory } from "react-router-dom";
import { MuiThemeProvider } from "@material-ui/core/styles";
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';

// styles
import useStyles,{getMuiTheme} from "./styles";

export default function Error({title="Something went wrong!",type="error"}) { console.log("Title",title)
  var classes = useStyles();
  const theme = useTheme();
//let history = useHistory();
  return (
      <MuiThemeProvider theme={getMuiTheme(theme)}>
    <Grid container className={classes.container}>
      <Paper classes={{ root: classes.paperRoot }}>
        
        {type==="error"?<ErrorOutlineIcon className={classnames(classes.textRow, classes.errorCode)} />:""}
        {type==="warning"?<FindInPageIcon className={classnames(classes.textRow, classes.errorCode)} />:""}
        {type==="loading"?<HourglassEmptyIcon className={classnames(classes.textRow, classes.errorCode)} />:""}
        {/* <Typography
          variant="h1"
          color="primary"
          
        >
          Error
        </Typography> */}
        <Typography
          variant="h6"
          color="text"
          colorBrightness="secondary"
          className={classnames(classes.textRow, classes.safetyText)}
        >
          {title}
        </Typography>
        {/* <Button
          variant="outlined"
          color="primary"
          // component={Link}
          // to="/app/Home"
          size="large"
          className={classes.backButton}
          onClick={()=>window.location.reload()}
        >
          Try Again!
        </Button> */}
        
      </Paper>
    </Grid>
    </MuiThemeProvider>
  );
}
